// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6045 ? "PatientStoriesModal" : chunkId) + "." + {"943":"efb950c00116071a","5264":"43c3877213da90cd","6045":"09ecbb52c0e97f14"}[chunkId] + ".js";
};